import { useFormikContext } from "formik";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { getMedidasPreventivas } from "../../../../../redux/actions/resolucion";
import MedidasPreventivasFormContainer from "./MedidasPreventivasFormContainer";
import MedidasPreventivasTable from "./MedidasPreventivasTable";


const MedidasPreventivasTabContainer = ({ }) => {
  const dispatch = useDispatch();
  const { values, setFieldValue } = useFormikContext()

  const [openForm, setOpenForm] = useState();

  useEffect(() => {
    dispatch(getMedidasPreventivas())
  }, [openForm])

  const handleDelete = (idToDelete) => {
    setFieldValue("medidasPreventivas", values.medidasPreventivas.filter((e) => e.idMedidaPreventiva !== idToDelete))
  }

  const handleAdd = (medidaPreventiva) => {
    setFieldValue("medidasPreventivas", [...values.medidasPreventivas, medidaPreventiva]);
    setOpenForm(false);
  }

  return (
    <>

      <MedidasPreventivasTable
        handleDelete={handleDelete}
        handleOpenAddForm={() => setOpenForm(true)}
        data={values.medidasPreventivas}
      />
      <MedidasPreventivasFormContainer
        open={openForm}
        handleClose={() => setOpenForm(false)}
        handleSubmit={handleAdd}
        selectedOptions={values.medidasPreventivas}
      />
    </>
  )
}

export default MedidasPreventivasTabContainer;